 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/EBB'
 import LOVE1 from '@/components/love1'
 import CARER36 from '@/components/Carer36'
 import CARER37 from '@/components/Carer37'
 import CARER38 from '@/components/Carer38'
 import CARER40 from '@/components/Carer40'
 import CARER41 from '@/components/Carer41'
 import CARER42 from '@/components/Carer42'
 import CARER43 from '@/components/Carer43'
 import CARER44 from '@/components/Carer44'
 import CARER45 from '@/components/Carer45'
 import CARER46 from '@/components/Carer46'
 import CARER47 from '@/components/Carer47'
 import CARER48 from '@/components/Carer48'
 import CARER49 from '@/components/Carer49'
 import CARER50 from '@/components/Carer50'
 import CARER51 from '@/components/Carer51'
 import CARER52 from '@/components/Carer52'
 import CARER53 from '@/components/Carer53'
 import CARER54 from '@/components/Carer54'
 import CARER55 from '@/components/Carer55'
 import CARER56 from '@/components/Carer56'
 import CARER57 from '@/components/Carer57'
 import CARER58 from '@/components/Carer58'
 import CARER59 from '@/components/Carer59'
 import CARER60 from '@/components/Carer60'
 import CARER61 from '@/components/Carer61'
 import CARER62 from '@/components/Carer62'
 import CARER63 from '@/components/Carer63'
 import CARER64 from '@/components/Carer64'
 import CARER65 from '@/components/Carer65'
 import CARER66 from '@/components/Carer66'
 import CARER67 from '@/components/Carer67'
 import CARER68 from '@/components/Carer68'
 import CARER69 from '@/components/Carer69'
 import CARER70 from '@/components/Carer70'
 import CARER71 from '@/components/Carer71'
 import CARER72 from '@/components/Carer72'
 import CARER73 from '@/components/Carer73'
 import CARER74 from '@/components/Carer74'
 import LOVE2 from '@/components/love2'
 import CARER75 from '@/components/Carer75'
 import COPYRIGHT from '@/components/Copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/EBB",
 			"name" : "EBB",
 			"component" : EBB
 		},
 		{
 			"path" : "/love1",
 			"name" : "love1",
 			"component" : LOVE1
 		},
 		{
 			"path" : "/Carer36",
 			"name" : "Carer36",
 			"component" : CARER36
 		},
 		{
 			"path" : "/Carer37",
 			"name" : "Carer37",
 			"component" : CARER37
 		},
 		{
 			"path" : "/Carer38",
 			"name" : "Carer38",
 			"component" : CARER38
 		},
 		{
 			"path" : "/Carer40",
 			"name" : "Carer40",
 			"component" : CARER40
 		},
 		{
 			"path" : "/Carer41",
 			"name" : "Carer41",
 			"component" : CARER41
 		},
 		{
 			"path" : "/Carer42",
 			"name" : "Carer42",
 			"component" : CARER42
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js